import Joi from '../../../Lib/Utils/Joi';

export type PurchaseOrderRevisionForm = {
  reason_for_request?: string;
  due_date?: {
    new_fob_ship_date_value?: string;
    new_value?: string;
    late_reason?: string;
    note?: string;
    vendor_acknowledged?: boolean;
  };
  items?: Array<{
    style_color: string;
    sizes?: Array<{
      line_item_id: number;
      new_quantity: number;
    }>;
    prices?: {
      junior?: number;
      plus?: number;
    };
    comment?: string;
  }>;
};

export type UpdatePurchaseOrderRevisionForm = (
  cb: (prev: PurchaseOrderRevisionForm) => PurchaseOrderRevisionForm,
) => void;

export const PurchaseOrderRevisionFormSchema = (isFca: boolean) =>
  Joi.object({
    reason_for_request: Joi.string().required().messages({
      'any.required': 'Please provide a reason for the request.',
      'string.empty': 'Please provide a reason for the request.',
    }),
    due_date: Joi.object({
      ...(isFca
        ? {
            new_fob_ship_date_value: Joi.string().required().messages({
              'any.required':
                'Please provide an updated requested FOB ship date or deselect this option.',
            }),
          }
        : {}),
      new_value: Joi.string().required().messages({
        'any.required':
          'Please provide an updated requested due date or deselect this option.',
      }),
      late_reason: Joi.string()
        .required()
        .messages({
          'any.required': `Please select a reason for the ${isFca ? 'FOB ship' : 'due'} date change request.`,
        }),
      note: Joi.string().messages({
        'string.empty': `Please provide details about the ${isFca ? 'FOB ship' : 'due'} date change request.`,
      }),
      vendor_acknowledged: Joi.boolean().valid(true).optional(),
    }),
    items: Joi.array()
      .items(
        Joi.object({
          style_color: Joi.string().required(),
          sizes: Joi.array()
            .items(
              Joi.object({
                line_item_id: Joi.number().required(),
                new_quantity: Joi.number().integer().min(0).required(),
              }),
            )
            .min(1)
            .messages({
              'number.min': 'negative_qty',
              'array.min':
                'Provide at least 1 quantity change or deselect this option.',
            }),
          prices: Joi.object({
            junior: Joi.number().precision(2).greater(0),
            plus: Joi.number().precision(2).greater(0),
          })
            .or('junior', 'plus')
            .messages({
              'object.missing':
                'Please provide a price change or deselect this option.',
              'number.greater': 'negative_cost',
            }),
          comment: Joi.string().messages({
            'string.empty':
              'Provide details of the other changes you wish to make or deselect this option.',
          }),
        })
          .or('sizes', 'prices', 'comment')
          .messages({
            'object.missing': 'Please provide at least one update.',
          }),
      )
      .min(1),
  })
    .or('due_date', 'items')
    .messages({
      'object.missing': 'Please provide at least one item to update.',
    });

export type FormErrors = Record<string, string>;
